export const ceilValueIfBelowX = (value: number, threshold: number): number => {
  return value >= threshold ? Math.floor(value) : Math.ceil(value)
}
